import { createContext, useContext, useState } from "react";
import { WaitlistDialog } from "@/components/site/WaitlistDialog";

const WaitlistCtx = createContext(null);

export const WaitlistProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, fonte: "home" });
  const openWaitlist = (fonte = "home") => setState({ open: true, fonte });
  return (
    <WaitlistCtx.Provider value={{ openWaitlist }}>
      {children}
      <WaitlistDialog
        open={state.open}
        fonte={state.fonte}
        onOpenChange={(open) => setState((s) => ({ ...s, open }))}
      />
    </WaitlistCtx.Provider>
  );
};

export const useWaitlist = () => useContext(WaitlistCtx);
